






































import { Component, Prop, Vue } from 'vue-property-decorator'

type ICrossCheckStage = CrossCheckStage

@Component({})
export default class CrossCheckStage extends Vue {
  @Prop() private readonly stage!: ICrossCheckStage

  changeAnswerOf(answer: ICrossCheckAnswer, value: string) {
    answer.userAnswer = value
  }
}
